import React, { useState } from "react";
import useForm from './hooks/useForm';
import FormField from "./CommonComponents/FormField";
import { Button } from './CommonComponents/BaseComponents'
import LoadingIcon from "./CommonComponents/Animations/LoadingIcon";
import useFetch from './hooks/useFetch';
// import background from './images/background-blue.png';
import useMediaQuery from './hooks/useMediaQuery';
import SeasonSelector from "./SeasonSelector";

export default () => {
  const isSmallView = useMediaQuery('(max-width: 620px)');

  const fetch = useFetch();

  const [isBusy, setIsBusy] = useState(false);
  const [showInvalidLogin, setShowInvalidLogin] = useState(false);

  const [showSeasonSelector, setShowSeasonSelector] = useState(false);

  const formSchema = {
    requiredFields: ['code'],
    initData: {
      code: ''
    }
  }

  const customCodeMap = {
    // launch activities:
    'AA1LS0': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=0&phase=1&classCode=99999&hasReachedLaunchActivity=true',
    'SF1LS0': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=0&phase=1&classCode=99999&hasReachedLaunchActivity=true',
    'AA2LS0': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=0&phase=1&classCode=99999&hasReachedLaunchActivity=true',
    'SF2LS0': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=0&phase=1&classCode=99999&hasReachedLaunchActivity=true',
    // apex 1 challenge:
    'AA1CH1': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=1&phase=3&classCode=99999',
    'AA1CH2': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=2&phase=3&classCode=99999',
    'AA1CH3': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=3&phase=3&classCode=99999',
    'AA1CH4': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=4&phase=3&classCode=99999',
    'AA1CH5': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=5&phase=3&classCode=99999',
    'AA1CH6': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=6&phase=3&classCode=99999',
    'AA1CH7': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=7&phase=3&classCode=99999',
    // apex 1 explore:
    'AA1EX1': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=1&phase=1&classCode=99999',
    'AA1EX2': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=2&phase=1&classCode=99999',
    'AA1EX3': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=3&phase=1&classCode=99999',
    'AA1EX4': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=4&phase=1&classCode=99999',
    'AA1EX5': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=5&phase=1&classCode=99999',
    'AA1EX6': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=6&phase=1&classCode=99999',
    'AA1EX7': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=7&phase=1&classCode=99999',
    // apex 2 challenge:
    'AA2CH1': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=1&phase=3&classCode=99999',
    'AA2CH2': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=2&phase=3&classCode=99999',
    'AA2CH3': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=3&phase=3&classCode=99999',
    'AA2CH4': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=4&phase=3&classCode=99999',
    'AA2CH5': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=5&phase=3&classCode=99999',
    'AA2CH6': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=6&phase=3&classCode=99999',
    'AA2CH7': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=7&phase=3&classCode=99999',
    // apex 2 explore:
    'AA2EX1': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=1&phase=1&classCode=99999',
    'AA2EX2': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=2&phase=1&classCode=99999',
    'AA2EX3': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=3&phase=1&classCode=99999',
    'AA2EX4': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=4&phase=1&classCode=99999',
    'AA2EX5': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=5&phase=1&classCode=99999',
    'AA2EX6': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=6&phase=1&classCode=99999',
    'AA2EX7': 'https://playquestboxes.com/game/?season=402&studentActivity=true&episode=7&phase=1&classCode=99999',
    // apex 1 checkpoint:
    'AA1CP1': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=1&phase=6',
    'AA1CP2': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=2&phase=6',
    'AA1CP3': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=3&phase=6',
    'AA1CP4': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=4&phase=6',
    'AA1CP5': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=5&phase=6',
    'AA1CP6': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=6&phase=6',
    'AA1CP7': 'https://playquestboxes.com/game/?season=401&studentActivity=true&episode=7&phase=4', // Note: phase=4 for episode 7 checkpoint
    // starforce 1 explore:
    'SF1EX1': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=1&phase=1&classCode=99999',
    'SF1EX2': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=2&phase=1&classCode=99999',
    'SF1EX3': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=3&phase=1&classCode=99999',
    'SF1EX4': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=4&phase=1&classCode=99999',
    'SF1EX5': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=5&phase=1&classCode=99999',
    'SF1EX6': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=6&phase=1&classCode=99999',
    'SF1EX7': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=7&phase=1&classCode=99999',
    // starforce 2 explore:
    'SF2EX1': 'https://playquestboxes.com/game/?season=502&studentActivity=true&episode=1&phase=1&classCode=99999',
    'SF2EX2': 'https://playquestboxes.com/game/?season=502&studentActivity=true&episode=2&phase=1&classCode=99999',
    'SF2EX3': 'https://playquestboxes.com/game/?season=502&studentActivity=true&episode=3&phase=1&classCode=99999',
    'SF2EX4': 'https://playquestboxes.com/game/?season=502&studentActivity=true&episode=4&phase=1&classCode=99999',
    'SF2EX5': 'https://playquestboxes.com/game/?season=502&studentActivity=true&episode=5&phase=1&classCode=99999',
    'SF2EX6': 'https://playquestboxes.com/game/?season=502&studentActivity=true&episode=6&phase=1&classCode=99999',
    'SF2EX7': 'https://playquestboxes.com/game/?season=502&studentActivity=true&episode=7&phase=1&classCode=99999',
    // starforce 1 checkpoint:
    'SF1CP1': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=1&phase=6',
    'SF1CP2': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=2&phase=6',
    'SF1CP3': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=3&phase=6',
    'SF1CP4': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=4&phase=6',
    'SF1CP5': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=5&phase=6',
    'SF1CP6': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=6&phase=6',
    'SF1CP7': 'https://playquestboxes.com/game/?season=501&studentActivity=true&episode=7&phase=6',
  }

  const formData = useForm(formSchema)

  const onClickSubmit = async () => {
    const { code: codeRaw = '' } = formData.values;
    const code = codeRaw.toUpperCase();

    const customCodes = Object.keys(customCodeMap)

    if (code === '99999') {
      setShowSeasonSelector(true)
    } else if (customCodes.includes(code)) {
      const customCodeUrl = customCodeMap[code]
      window.open(customCodeUrl,'_self');
    } else {
      onCheckCodeAndRoute(code)
    }    
  }

  const onCheckCodeAndRoute = async (code) => {
    if (formData.isValid() && !isBusy) {
      setIsBusy(true)

      const response = await fetch(
        `quest/code/redeemed?code=${code}`, 
        { 
          method: 'GET',
        }
      )

      const jsonData = await response.json() || {};

      const { 
        success,
        code: questCode = '',
        // classId = '',
        seasonIndex = '',
        episodeIndex = '',
        phase = '',
        classId = '',
        hasCompletedPostAssessment,
        hasReachedLaunchActivity,
        // classLevel,
      } = jsonData;

      if (success && questCode && seasonIndex) {
        setShowInvalidLogin(false)
        routeToDestination(questCode, seasonIndex, episodeIndex, phase, classId, hasCompletedPostAssessment, hasReachedLaunchActivity)
      } else {
        setShowInvalidLogin(true)
      }

      setIsBusy(false)
    }
  }

  const onSeasonSelected = (seasonIndex) => {
    if (seasonIndex) {
      routeToDestination(99999,seasonIndex,-1)
    } else {
      setShowSeasonSelector(false)
    }
  }

  const routeToDestination = (questCode, seasonIndex, episodeIndex, phase, classId, hasCompletedPostAssessment, hasReachedLaunchActivity) => {
    // Old link for reference
    // const primaryValue = classLevel?.toLowerCase().includes("primary") ? '1' : '0';
    // const seasonLink = `https://playquestboxes.com/game?classid=${classId}&season=${seasonIndex}&student=1`;

    const seasonLink = `https://playquestboxes.com/game?classCode=${questCode}&season=${seasonIndex}&episode=${episodeIndex}&phase=${phase}&classId=${classId}&hasCompletedPostAssessment=${hasCompletedPostAssessment}&hasReachedLaunchActivity=${hasReachedLaunchActivity}&studentActivity=true`;
    window.open(seasonLink,'_self');
    // console.log(seasonLink)
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSubmit();
    }
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: isSmallView ? 'column' : 'row',
      rowGap: '15px',
      // padding: '20px',
      height: '100%',
      boxSizing: 'border-box',
      overflow: 'auto',
      overflowX: 'hidden',
      // background: '#ffffff'
      // background: `url(${background})  top left/cover no-repeat fixed`
      background: `url("https://api.portal.questboxes.com/api/file/Product%20Images/playquestboxes-splash.png") top left/cover no-repeat fixed`
    }}>
    { 
      showSeasonSelector ?
      <SeasonSelector onSeasonSelected={onSeasonSelected} />
      :
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: isSmallView ? 'flex-start' : 'center',
        alignItems: 'center',
        padding: '20px',
        zIndex: '100',
        marginTop: isSmallView ? '-15px' : '0px'
      }}>

       <div style={{ display: 'flex', flexDirection: 'column' }}>

          <div style={{ flex: 1, display: 'flex', marginBottom: '20px', textAlign: isSmallView ? 'center' : 'center' }}>
            <div style={{ color: '#ffffff'}}>
              <div style={{ fontWeight: 'bold', fontSize: '40px', marginBottom: '0px', color: '#ffc200' }}>{"ENTER CLASS CODE"}</div>
              {/* <div style={{ fontSize: '26px', maxWidth: isSmallView ? 'none' : '600px'}}>
                {"Please enter your provided Quest Code to gain access!"}
              </div> */}
            </div>
          </div>

          <FormField
            fieldStyle={{ 
              fontSize: '18px', 
              textAlign: 'center',
              textTransform: 'uppercase'
            }}
            // label='Code'
            // labelStyle={{ color: '#ffffff', fontWeight: 'bold'}}
            fieldId='code'
            type='text'
            // placeholder='Email'
            formData={formData}
            onKeyDown={onKeyDown}
          />

          <div style={{ height: '25px', position: 'relative'}}>

          {
            (!isBusy && showInvalidLogin) ?
            <div style={{
              color: '#ef0c0c',
              fontStyle: 'italic',
              fontSize: '14px',
              position: 'absolute',
              top: '3px',
              left: '3px'
            }}>
              {'Code not found or has not been redeemed by your teacher.'}
            </div>
            :
            <div>&nbsp;</div>
          }

          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: isSmallView ? 'center' : 'center' }}>
            <Button 
              style={{ 
                display: 'inline-flex', 
                marginRight: '10px', 
                fontWeight: 'bold', 
                fontSize: '24px',
                width: '150px', 
                height: '40px',
                background: 'transparent'
              }} 
              onClick={onClickSubmit} 
              $colored={true}
            >
                {'SUBMIT'}
            </Button>
            {
              isBusy &&
              <LoadingIcon />
            }
          </div>

        </div>
      </div>
    }
    </div>
  )
}